import * as YAML from "yaml";
import { parseYamlModel } from "./modelYamlImportParser";

export const importFromYaml = (text) => {
  try {
    const _model = YAML.parse(text);

    parseYamlModel(_model);

    return {model:_model, error: null};
  } catch (e) {
    console.log(e.message);
    return {model: null, error: `The model is erroneous. ${e.message}`};
  }
};
